import script from "./ViewAllSOPFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllSOPFiles.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllSOPFiles.vue?vue&type=style&index=0&id=773db0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-773db0c8"]])

export default __exports__